import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import UploadOutlined from "@mui/icons-material/UploadOutlined";
import ReceiptLongOutlined from "@mui/icons-material/ReceiptLongOutlined";
import MenuBookOutlined from "@mui/icons-material/MenuBookOutlined";
import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import MailOutlined from "@mui/icons-material/MailOutlined";

// The fixed set of MUI icons the picker offers - matching
// documentTypeIcons.js's ICONS_BY_NAME (Kundenportal) and
// DocumentType::ICONS (BE), by icon name rather than by slug: any document
// type, not just the six known Dokumentarten, picks from this same set.
export const DOCUMENT_TYPE_ICON_OPTIONS = [
  { name: "DescriptionOutlined", Icon: DescriptionOutlined },
  { name: "UploadOutlined", Icon: UploadOutlined },
  { name: "ReceiptLongOutlined", Icon: ReceiptLongOutlined },
  { name: "MenuBookOutlined", Icon: MenuBookOutlined },
  { name: "Inventory2Outlined", Icon: Inventory2Outlined },
  { name: "MailOutlined", Icon: MailOutlined },
];

export function iconComponentForName(name) {
  return DOCUMENT_TYPE_ICON_OPTIONS.find((option) => option.name === name)?.Icon ?? null;
}
